// src/PrintCode.js
import React, { useEffect } from 'react';
import QRCode from 'react-qr-code';
import { useQuery } from '../../hook/useQuery';

const PrintCode = () => {
  useEffect(() => {
    setTimeout(() => {
      window.close();
    }, 2000);
  }, []);

  const query = useQuery();
  const styles = {
    body: {
      fontFamily: 'Arial, sans-serif',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'auto',
      margin: 0,
      background: 'white'
    },
    receipt: {
      //   border: "1px solid #000",
      padding: '10px',
      width: '300px',
      textAlign: 'center',
      border: '1px solid black',
      display: 'flex',
      justifyContent: 'space-between'
    },
    heading: {
      textAlign: 'left',
      margin: '0px 0 0px',
      fontSize: '13px'
    },
    headingName: {
      textAlign: 'left',
      fontSize: '15px',
      margin: '0px 0 0px'
    },
    option: {
      marginLeft: '14px'
    },
    img: {
      marginTop: '10px',
      width: '150px',
      height: '150px'
    },
    noPrint: {
      marginTop: '20px',
      textAlign: 'center'
    },
    underline: {
      textDecoration: 'underline'
    },
    box: {
      display: 'flex'
    },
    '@media print': {
      noPrint: {
        display: 'none'
      }
    }
  };

  const vCardData = `BEGIN:VCARD
VERSION:3.0
FN:${query.get('name') ?? ''}
TEL;TYPE=CELL:${query.get('contact') ?? ''}
EMAIL:${query.get('email')}
ORG:${query.get('company') ?? ''}
END:VCARD`;

  return (
    <div style={styles.body}>
      <div style={styles.receipt}>
        <div>
          <div style={styles.headingName}>
            <strong>{query.get('name') ?? ''}</strong>
          </div>
          <p style={styles.heading}>
            <strong>{query.get('company') ?? ''}</strong>
          </p>
          <p style={styles.heading}><strong>{query.get('email') ?? ''}</strong></p>
        </div>

        <div style={styles.option}>
          <QRCode
            size={256}
            style={{
              height: 'auto',
              maxWidth: '60px',
              width: '100%',
              margin: '0px 0px 0px 0px'
            }}
            value={vCardData}
          />
        </div>
        {/* <div style={styles.noPrint}>
          <button onClick={() => window.print()}>Print PrintCode</button>
        </div> */}
      </div>
    </div>
  );
};

export default PrintCode;
